angular
  .module('pb.core.user')

  .directive('pbCanUpdate', [
    'LoggedUser',

    function(LoggedUser) {
      return {
        restrict: 'A',
        priority: 998,
        link: function(scope, element, attrs) {
          var resourceType = attrs.pbCanUpdate,
            resources = LoggedUser.get().getResources();

          if (!resourceType) {
            return;
          }

          if (
            typeof resources !== 'object' ||
            !resources[resourceType] ||
            !angular.isArray(resources[resourceType])
          ) {
            element.remove();
            return;
          }

          if (resources[resourceType].indexOf('update') >= 0) {
            //remove the attribute to avoid infinite loop
            element.removeAttr('pb-can-update');
          } else {
            element.remove();
          }
        }
      };
    }
  ]);
